// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__p6pRV","content":"styles_content__1L3Of","checkbox":"styles_checkbox__35JTe","checkboxLabel":"styles_checkboxLabel__17C9v"};